module.exports = __webpack_public_path__ + "img/telos.1eb50c1a.png";